import { render, staticRenderFns } from "./UploadFileDesktop.vue?vue&type=template&id=f6da7a76"
import script from "./UploadFileDesktop.vue?vue&type=script&lang=js"
export * from "./UploadFileDesktop.vue?vue&type=script&lang=js"
import style0 from "./UploadFileDesktop.vue?vue&type=style&index=0&id=f6da7a76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports